<div class="header flex items-center">
  @if (user() !== null) {
  <app-player-row
    [style.cursor]="isMenuless(user()) ? 'default' : 'pointer'"
    (click)="
      isMenuless(user())
        ? null
        : contextMenuService.open($event, { user: user()! })
    "
    [player]="user()!"
    [rowSettings]="color() ? {
      avatar: {
        borderColor: color(),
        filter: 'drop-shadow(0px 0px 12px ' + color() + 66 + ')',
      }
    } : null"
  ></app-player-row>
  }
  <div class="skins-price">
    Total Value:
    <app-balance-icon />
    {{ totalValue() | number : "1.2-2" }}
  </div>
  <div class="game-id-wrapper">
    <div
      class="gameid"
      (click)="
        clipboardService.copy(game().gameid, 'GameID copied to clipboard')
      "
    >
      GameID:
      {{ game().gameid }}
    </div>
  </div>
</div>
<div class="divider horizontal w-full"></div>
<div class="skins">
  <app-skins-list
    [skins]="skins()"
    [selectable]="false"
    [config]="{ mobile: { skin_min_width: '130px' } }"
  />
</div>
